import * as focusTrap from 'focus-trap';

const mainMenu = document.querySelector( '.main-menu .menu' );
const mobileMenuToggle = document.querySelector( '[data-open-menu]' );
const masthead = document.querySelector( '.masthead .container--full' );
const homeLink = document.querySelector( '.home--link' );

let trap = focusTrap.createFocusTrap( masthead, {
  onActivate: () => {
    masthead.classList.toggle( 'menu-open' );
    mobileMenuToggle.classList.toggle( 'menu-open' );
    document.body.classList.toggle( 'menu-open' );
  },
  onDeactivate: () => {
    masthead.classList.toggle( 'menu-open' );
    mobileMenuToggle.classList.toggle( 'menu-open' );
    document.body.classList.toggle( 'menu-open' );
  },
  initialFocus: homeLink,
  fallbackFocus: homeLink,
} );

function initMobileMenu() {

  if (mobileMenuToggle) {
    mobileMenuToggle.addEventListener( 'click', (event) => {
      event.preventDefault();

      trap.active ? trap.deactivate() : trap.activate();
    } );
  }
}

export default {
  init() {
    initMobileMenu();
  },
};